module.exports = __webpack_public_path__ + "static/img/4839_phase_function_Paper_PointsHejduk_Prediction.e8d2926.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4839_phase_function_Paper_PointsHejduk_Prediction.png
// module id = xhPl
// module chunks = 0